import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import imgCloseBtn from '../../images/common/i_close_btn.svg';
import hosApptInfo from '../../assets/json/hosApptInfo.json';
// WebViewBridge에서 handleAppLaunch 임포트
import { handlePhoneCall, handleAppLaunch } from '../../constants/webViewBridge';

// 병원케어 > 진료예약

const ContentWrap = styled.div`
    display: block;
`;

const InnerBox = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: flex-start; 
    justify-content: center; 
    padding: 1.6rem; 
    & > strong {
        display: block;
        width: 100%;
        font-size: var(--mo-fz-lg); 
        color: var(--color-main-gray); 
    }
    & > span {
    display: block;
    width: 100%;
    margin-top: var(--sp-12);
    text-align: center;
    font-size: var(--mo-fz-smd); 
    color: var(--color-main-gray); 
    }
    &  .close-btn {
        position: absolute; 
        top: var(--sp-16); 
        right: var(--sp-16);
        width: var(--sp-24); 
        height: var(--sp-24);
        background: url(${imgCloseBtn}) no-repeat center;
        background-size: 100%;
        z-index: 10;
    }
`;

const ContentBox = styled.div`
    display: block;
    width: 100%;
    margin-top: var(--sp-24);
`;

const ListBox = styled.ul`
    display: flex;
    flex-direction: column;
    gap: var(--sp-12);
`;

const List = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    & a {
        display: flex;
        align-items: center; 
        justify-content: center; 
        position: relative;
        width: 100%;
        height: var(--sp-62);
        border-radius: var(--radius-12);
        background-color: var(--color-main-gray-45);
        text-align: center;
        & b {
            color: var(--color-main-5)
        }    
    }
    & .reservation_link {
        display: flex;
        align-items: center; 
        justify-content: center; 
        position: relative;
        width: 100%;
        height: var(--sp-62);
        border-radius: var(--radius-12);
        background-color: var(--color-main-gray-45);
        text-align: center;
        & b {
            color: var(--color-main-5)
        } 
    }    
    & .hit-txt-box {
        display: inline-flex;
        align-items: center; 
        justify-content: center; 
        height: var(--sp-18);
        position: absolute;
        bottom: calc(100% - 0.9rem);
        left: var(--sp-16);
        padding: 0 var(--sp-08);
        border-radius: var(--radius-100);
        background-color:#D83B3B;
        font-size: var(--mo-fz-xxsm);
        color: var(--color-white);
        font-weight: var(--fz-weight-700);
    }
`;

const BottomBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center; 
    width: 100%;
    margin-top:var(--sp-16);
    & p {
        font-size: var(--mo-fz-smd);
        color: var(--ccolor-main-gray);
        
    }
`;

const MedicalReservation = ({onClose, hsptlCd, hsptlNm}) => {

    const hospital = hosApptInfo.find(h => h.code === hsptlCd);

    const handleCall = ()=> {
        if (hospital && hospital.call) {
            handlePhoneCall(hospital.call);
        }
    }

    /**
     * 모바일 앱 버튼 클릭 시 브릿지로 스킴/스토어 정보 전달
     */
    const handleAppClick = (e) => {
        e.preventDefault(); 
        
        if (hospital && hospital.app) {
            handleAppLaunch(hospital.app); 
        } else {
            console.error('Hospital app info is missing.');
        }
    };

    // IOS 새창 - 유틸 함수 추가
    const openExternalUrl = (url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: url
            }));
        } else {
            window.open(url, '_blank');
        }
    };
    
    // 병원 정보가 없을 경우를 대비한 방어 코드
    if (!hospital) {
        return (
            <ContentWrap>
                <InnerBox>
                    <strong>진료 예약</strong>
                    <span>병원 정보를 찾을 수 없습니다.</span>
                    <button className='close-btn' onClick={onClose}>
                        <span className='blind'>팝업 닫기</span>
                    </button>
                </InnerBox>
            </ContentWrap>
        );
    }

    return (
        <ContentWrap>
            <InnerBox>
                <strong>
                    진료 예약
                </strong>
                <span> {hsptlNm} 병원 진료 예약은 아래 서비스에서 가능합니다. </span>
                <ContentBox>
                    <ListBox>
                        <List>
                            {/* <Link to={hospital.kakao} target="_blank" rel="noopener noreferrer" draggable={false} > */}
                            <div onClick={() => openExternalUrl(hospital.kakao)} style={{ cursor: 'pointer' }} draggable={false} className='reservation_link'>
                                <p>{hsptlNm} 병원 <b>카카오톡 케어챗</b> 바로가기</p>
                                <span className='hit-txt-box'>쉽고 빠른 예약</span>
                            </div>
                            {/* </Link> */}
                        </List>
                        <List>
                            {/* [수정됨] <Link> 대신 <a> 태그와 onClick 핸들러 사용 */}
                            <a href="#" onClick={handleAppClick} rel="noopener noreferrer" draggable={false}>
                                <p>{hsptlNm} 병원 <b>모바일 앱</b> 바로가기</p>
                            </a>
                        </List>
                        <List>
                            <div onClick={() => openExternalUrl(hospital.mobile)} style={{ cursor: 'pointer' }} draggable={false} className='reservation_link'>
                                <p>{hsptlNm} 병원 <b>모바일 홈페이지</b> 바로가기</p>
                            </div>  
                        </List>
                    </ListBox>

                </ContentBox>

                <BottomBox>
                    <p>진료 예약 관련 궁금하신 점이 있으시면</p>
                    <p><b onClick={handleCall}>{hospital.call}</b> 으로 문의 바랍니다.</p>     
                                
                </BottomBox>

                <button className='close-btn' onClick={onClose}>
                    <span className='blind'>팝업 닫기</span>
                </button>
            </InnerBox>
        </ContentWrap>
    );
};

export default MedicalReservation;